export default __webpack_public_path__ + "static/media/filter.8d40edde.svg";